import React from "react";
import { Icon, Popover } from "@ebscois/react-component-library";

import { NameHolder, Pronunciation, Chip, Name, LogoWrapper } from "./_.styled";
import { StyledLogo } from "../_.styled";

import AudioPlayer from "../../../AudioComponent";
import BoxedWarning from "../../../BoxedWarning";

const TopicName = ({
  icon,
  pageHeading,
  pronunciation,
  hasAudio,
  togglePlay,
  tags,
  logo,
  boxedWarnings,
  boxedWarningProps,
}) => {
  return (
    <NameHolder>
      <Name>
        {icon && (
          <>
            <Icon
              icon={{
                glyph: icon.glyph,
                color: icon.color,
                size: icon.size,
              }}
              data-testid={icon.testId}
            />
            &nbsp;
          </>
        )}
        {pageHeading}
        <span>
          {pronunciation && (
            <Pronunciation
              dangerouslySetInnerHTML={{ __html: pronunciation }}
            />
          )}
          {hasAudio && <AudioPlayer togglePlay={togglePlay} />}
        </span>
      </Name>
      {tags && (
        <div>
          {tags.map(({ label, variant, testId, id, message }) => {
            // disable neo/ped pill icon until further notice
            //            return message ? (
            return (
              message && (
                <Popover
                  placement="bottom"
                  key={id}
                  data-testid={testId}
                  trigger={
                    <Chip element="button" label={label} variant={variant} />
                  }
                  popperComponentProps={{
                    variant: "primary",
                    width: "small",
                  }}
                >
                  {message}
                </Popover>
                //            ) : (
                //              <Chip
                //                key={id}
                //                data-testid={testId}
                //                label={label}
                //                variant={variant}
                //              />
              )
            );
          })}
        </div>
      )}
      {boxedWarnings?.value?.[0] && <BoxedWarning {...boxedWarningProps} />}
      {logo && (
        <LogoWrapper data-testid="content-drug-logo">
          <StyledLogo src={logo.src} alt={logo.alt} />
        </LogoWrapper>
      )}
    </NameHolder>
  );
};

export default TopicName;
